import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

Injectable()
export class AppSettings {

    public apiBaseUrl: string;
    public apiFishTypeUrl:string;
    public apiCatchesUrl: string;
    public apiFactoriesUrl: string;
    public apiReleasesUrl: string;
    public apiRecapturesUrl: string;

    public readonly snackbar_action_label: string;
    public readonly snackbar_duration: number;

    constructor() {
      
        this.snackbar_action_label = 'close';
        this.snackbar_duration = 2000;
    }

}